import { RichTextEditor } from '@mantine/rte';
import { MantineProvider } from '@mantine/core';

export default function Editor({ currentJournal, updateJournalBody, updateJournalTitle, toggle, mode }) {

    return (
        <div className='w-screen min-h-screen'>
            <div className='max-w-7xl mx-auto h-screen'>
                <div className='flex gap-4 justify-between p-5 bg-white dark:bg-[#101010]'>
                    <div className='flex gap-2'>
                        <h4 className='md:text-xl text-lg font-bold my-auto dark:text-neutral-100'>Title:</h4>
                        <input 
                            className='md:text-lg text-base w-full pt-[3px] bg-white dark:bg-[#101010] focus:bg-white text-gray-800 dark:text-neutral-100 border-b-2 border-transparent focus:border-sky-600 focus:outline-none' id='a' 
                            value={currentJournal.title === 'Untitled' ? '' : currentJournal.title} placeholder='Untitled' autoComplete='off'
                            onChange={() => updateJournalTitle(document.getElementById('a').value === '' ? 'Untitled' : document.getElementById('a').value)} />
                    </div>
                    <div className=''>
                        <div onClick={toggle} className='rounded-lg px-5 py-2 bg-sky-600 w-fit text-white cursor-pointer hover:bg-sky-500 transition ease-in'>
                            <span>Close <p className='hidden md:inline-block'>Editor</p></span>
                        </div>
                    </div>
                </div>
                <MantineProvider theme={{ colorScheme: mode === true ? 'dark' : ''}}>
                    <RichTextEditor className='min-h-[calc(100vh-80px)]' value={currentJournal.body} onChange={updateJournalBody} />
                </MantineProvider>
            </div>
        </div>
    )
}